module.exports = __webpack_public_path__ + "img/filter.5926c257.svg";